import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'FORCE',
  version: 1,
  label: 'Force Index',
  pane: 'sub',
  category: 'momentum',
  series: 'volume',
  order: 290,
  inputs: [period('timeperiod', 13)],
  outputs: [line('force', 'Force', COLOR.blue)],
  levels: [{ value: 0 }],
  talib: { functions: ['EMA', 'MULT', 'MOM'], expr: 'EMA(MULT(MOM(close, timeperiod=1), volume), timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  // MOM(1) costs one bar, the EMA n−1 more.
  lookback: ({ timeperiod }) => timeperiod,
}
export default def
